<div [ngClass]="{ 'popup-container': isCellEditorPopup }">
  <app-dropdown-field
    #fieldComponent
    [form-control]="formControl"
    [field]="cellParams.field"
    [matSelectPanelClass]="matSelectPanelClass"
  ></app-dropdown-field>
</div>
